import { Pipe, PipeTransform } from '@angular/core';
import { ContentPipe } from '../../services/content/content.pipe';
import { LookerDashboardTypeEnum } from '../models/dashboard.enums';

@Pipe({
  standalone: true,
  name: 'lookerDashboardRouteToTitle',
})
export class LookerDashboardRouteToTitlePipe implements PipeTransform {

    constructor(
        private contentPipe: ContentPipe,
    ) {}

	transform(dashboardType: LookerDashboardTypeEnum): string {
    if (dashboardType ===  LookerDashboardTypeEnum.DsrAuditLog) {
      return this.contentPipe.transform('dashboard.dsrAuditLogTitle');
    }
    return this.contentPipe.transform('dashboard.title');
	}
}